import React, { useState, useEffect, useContext } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";
import { LoginContext } from "../context/LoginContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileAlt,
  faUserCircle,
  faStar,
  faPoll,
  faPen,
} from "@fortawesome/free-solid-svg-icons";

const Profile = (props) => {
  const loginContext = useContext(LoginContext);

  const [showProfile, setShowProfile] = useState(false);

  const [showPoll, setShowPoll] = useState(false);

  const [showMsg, setShowMsg] = useState(false);

  const [showSignup, setShowSignup] = useState(false);

  const [data, setData] = useState({});

  const [name, setName] = useState("");

  const [codeMelli, setCodeMelli] = useState("");

  const [address, setAddress] = useState("");

  const [work, setWork] = useState("");

  const [image, setImage] = useState({ preview: "", raw: "" });

  const [msg, setMsg] = useState("");

  const [imageRate, setImageRate] = useState(0);

  const [tanavoe, setTanavoe] = useState(0);

  const [khalaghiat, setKhalaghiat] = useState(0);

  const [gheymat, setGheymat] = useState(0);

  const [moshtariMadari, setMoshtariMadari] = useState(0);

  const [nokte, setNokte] = useState("");

  const [mobile, setMobile] = useState("");

  const [pass, setPass] = useState("");

  const [nameLogin, setNameLogin] = useState("");

  const [mobileValidate, setMobileValidate] = useState(true);

  const [passValidate, setPassValidate] = useState(true);

  const [nameValidate, setNameValidate] = useState(true);

  const [exist, setExist] = useState(0);

  const [result, setResult] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [theme, switchTheme] = useTheme();

  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

  useEffect(() => {
    const form = new FormData();
    form.append("getProfile", 1);
    form.append("vitrinCode", props.vitrinCode);
    form.append("mobile", loginContext.userInfo.mobile);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setName(data.data.name);
        setAddress(data.data.address);
        setCodeMelli(data.data.codeMelli);
        setWork(data.data.work);
        setImage({ preview: data.data.image, raw: "" });
        setData(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [loginContext, msg]);

  const nameHandle = (e) => {
    setName(e.target.value);
  };

  const addressHandle = (e) => {
    setAddress(e.target.value);
  };

  const codeMelliHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setCodeMelli(e.target.value);
  };

  const workHandle = (e) => {
    setWork(e.target.value);
  };

  const mobileHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setMobile(e.target.value);
  };

  const passHandle = (e) => {
    setPass(p2e(a2e(e.target.value)));
  };

  const nameLoginHandle = (e) => {
    setNameLogin(e.target.value);
  };

  const checkSignup = () => {
    if (mobile.length < 11 || mobile[0] + mobile[1] != "09") {
      setMobileValidate(false);
      return;
    } else {
      setMobileValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("checkSignup", 1);
    formData.append("mobile", mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setExist(1);
        } else {
          setExist(2);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const login = () => {
    if (pass.length < 4) {
      setPassValidate(false);
      return;
    } else {
      setPassValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("login", 1);
    formData.append("mobile", mobile);
    formData.append("password", pass);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          loginContext.login(data.data);
          setShowSignup(false);
        } else {
          setResult("رمز عبور اشتباه است");
          setExist(3);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const forgetPass = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("forget_pass", 1);
    formData.append("mobile", mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setResult(data.data);
          setExist(3);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const signup = () => {
    if (nameLogin.length < 6) {
      setNameValidate(false);
      return;
    } else {
      setNameValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("signUp", 1);
    formData.append("mobile", mobile);
    formData.append("name", nameLogin);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("address", "");
    formData.append("work", "مشتری خانگی");
    formData.append("moaref", "");
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setExist(4);
        } else {
          setExist(5);
        }
        setResult(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(5);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const submit = () => {
    setShowMsg(true);
    if (
      data.name === name &&
      data.codeMelli === codeMelli &&
      data.address === address &&
      data.work === work &&
      image.raw === ""
    ) {
      setMsg("تغییری اعمال نشد");
      return;
    }

    if (name.length < 6) {
      setMsg("نام و نام خانوادگی نامعتبر است");
      return;
    }

    if (codeMelli !== "" && codeMelli.length < 10) {
      setMsg("کد ملی نامعتبر است");
      return;
    }

    const form = new FormData();
    form.append("changeProfile", 1);
    form.append("vitrinCode", props.vitrinCode);
    form.append("mobile", loginContext.userInfo.mobile);
    form.append("name", name);
    form.append("codeMelli", codeMelli);
    form.append("address", address);
    form.append("work", work);
    form.append("file", image.raw);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setMsg(data.data);
        console.log(data);
      })
      .catch((e) => {
        setMsg("اشکال در برقراری ارتباط با سرور");
        console.log(e);
      });
  };

  const imageHandle = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const setRate = (type, rate) => {
    if (type === "imageRate") {
      setImageRate(rate);
    } else if (type === "tanavoe") {
      setTanavoe(rate);
    } else if (type === "khalaghiat") {
      setKhalaghiat(rate);
    } else if (type === "gheymat") {
      setGheymat(rate);
    } else if (type === "moshtariMadari") {
      setMoshtariMadari(rate);
    }
  };

  const nokteHandle = (e) => {
    setNokte(e.target.value);
  };

  const pollSubmit = () => {
    setShowPoll(false);
    setShowMsg(true);
    if (
      parseInt(imageRate) === 0 &&
      parseInt(tanavoe) === 0 &&
      parseInt(khalaghiat) === 0 &&
      parseInt(gheymat) === 0 &&
      parseInt(moshtariMadari) === 0
    ) {
      setMsg("حداقل یکی از امتیاز ها را پر کنید");
      return;
    }
    const form = new FormData();
    form.append("setVitrinPoll", 1);
    form.append("vitrinCode", props.vitrinCode);
    form.append("mobile", loginContext.userInfo.mobile);
    form.append("image", imageRate);
    form.append("tanavoe", tanavoe);
    form.append("khalaghiat", khalaghiat);
    form.append("gheymat", gheymat);
    form.append("moshtariMadari", moshtariMadari);
    form.append("nokte", nokte);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setMsg(data.data);
        console.log(data);
      })
      .catch((e) => {
        setMsg("اشکال در برقراری ارتباط با سرور");
        console.log(e);
      });
  };

  const modal = () => {
    return (
      <>
        <div className="card-text  text-center">
          <p>{"کیفیت عکس ها : " + imageRate}</p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={imageRate > 0 ? "yellow" : "grey"}
            onClick={() => {
              setRate("imageRate", 1);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={imageRate > 1 ? "yellow" : "grey"}
            onClick={() => {
              setRate("imageRate", 2);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={imageRate > 2 ? "yellow" : "grey"}
            onClick={() => {
              setRate("imageRate", 3);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={imageRate > 3 ? "yellow" : "grey"}
            onClick={() => {
              setRate("imageRate", 4);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={imageRate > 4 ? "yellow" : "grey"}
            onClick={() => {
              setRate("imageRate", 5);
            }}
          />
        </div>
        <div className="card-text mt-1  text-center border-top">
          <p className="mt-2">{"تنوع محصول : " + tanavoe}</p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={tanavoe > 0 ? "yellow" : "grey"}
            onClick={() => {
              setRate("tanavoe", 1);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={tanavoe > 1 ? "yellow" : "grey"}
            onClick={() => {
              setRate("tanavoe", 2);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={tanavoe > 2 ? "yellow" : "grey"}
            onClick={() => {
              setRate("tanavoe", 3);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={tanavoe > 3 ? "yellow" : "grey"}
            onClick={() => {
              setRate("tanavoe", 4);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={tanavoe > 4 ? "yellow" : "grey"}
            onClick={() => {
              setRate("tanavoe", 5);
            }}
          />
        </div>
        <div className="card-text mt-1  text-center border-top">
          <p className="mt-2">{"نوآوری و مدل های خلاقانه : " + khalaghiat}</p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={khalaghiat > 0 ? "yellow" : "grey"}
            onClick={() => {
              setRate("khalaghiat", 1);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={khalaghiat > 1 ? "yellow" : "grey"}
            onClick={() => {
              setRate("khalaghiat", 2);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={khalaghiat > 2 ? "yellow" : "grey"}
            onClick={() => {
              setRate("khalaghiat", 3);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={khalaghiat > 3 ? "yellow" : "grey"}
            onClick={() => {
              setRate("khalaghiat", 4);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={khalaghiat > 4 ? "yellow" : "grey"}
            onClick={() => {
              setRate("khalaghiat", 5);
            }}
          />
        </div>
        <div className="card-text mt-1  text-center border-top">
          <p className="mt-2">{"قیمت و اجرت های مناسب : " + gheymat}</p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={gheymat > 0 ? "yellow" : "grey"}
            onClick={() => {
              setRate("gheymat", 1);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={gheymat > 1 ? "yellow" : "grey"}
            onClick={() => {
              setRate("gheymat", 2);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={gheymat > 2 ? "yellow" : "grey"}
            onClick={() => {
              setRate("gheymat", 3);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={gheymat > 3 ? "yellow" : "grey"}
            onClick={() => {
              setRate("gheymat", 4);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={gheymat > 4 ? "yellow" : "grey"}
            onClick={() => {
              setRate("gheymat", 5);
            }}
          />
        </div>

        <div className="card-text mt-1  text-center border-top">
          <p className="mt-2">
            {"امتیاز جایزه و اهمیت به مشتری : " + moshtariMadari}
          </p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={moshtariMadari > 0 ? "yellow" : "grey"}
            onClick={() => {
              setRate("moshtariMadari", 1);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={moshtariMadari > 1 ? "yellow" : "grey"}
            onClick={() => {
              setRate("moshtariMadari", 2);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={moshtariMadari > 2 ? "yellow" : "grey"}
            onClick={() => {
              setRate("moshtariMadari", 3);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={moshtariMadari > 3 ? "yellow" : "grey"}
            onClick={() => {
              setRate("moshtariMadari", 4);
            }}
          />
          <FontAwesomeIcon
            icon={faStar}
            className="mx-1"
            color={moshtariMadari > 4 ? "yellow" : "grey"}
            onClick={() => {
              setRate("moshtariMadari", 5);
            }}
          />
        </div>
        <div className="card-text mt-1  text-center border-top">
          <p className="mt-2">{"نکته و یادداشت"}</p>
        </div>
        <textarea
          className="form-control rtl"
          value={nokte}
          onChange={nokteHandle}
        ></textarea>
      </>
    );
  };

  const loginModal = () => {
    if (!isLoading) {
      if (exist === 0) {
        return (
          <div>
            <h6 className="text-center">موبایل</h6>
            <input
              className={
                !mobileValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              onChange={mobileHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  checkSignup();
                }}
              >
                ادامه
              </button>
            </div>
          </div>
        );
      } else if (exist === 1) {
        return (
          <div>
            <h6 className="text-center">موبایل</h6>
            <input
              className="form-control rtl"
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              readOnly
            ></input>
            <h6 className=" mt-3 text-center">رمزعبور</h6>
            <input
              className={
                !passValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="password"
              value={pass}
              onChange={passHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-info mr-2"
                onClick={() => {
                  forgetPass();
                }}
              >
                فراوشی رمزعبور
              </button>
              <button
                className="btn btn-success"
                onClick={() => {
                  login();
                }}
              >
                ورود
              </button>
            </div>
          </div>
        );
      } else if (exist === 2) {
        return (
          <div>
            <h6 className="text-center">
              <FontAwesomeIcon
                onClick={() => {
                  setExist(0);
                }}
                icon={faPen}
              />{" "}
              موبایل
            </h6>
            <input
              className="form-control rtl"
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              readOnly
            ></input>
            <h6 className=" mt-3 text-center">نام و نام خانوادگی</h6>
            <input
              className={
                !nameValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="text"
              value={nameLogin}
              onChange={nameLoginHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  signup();
                }}
              >
                ثبت نام
              </button>
            </div>
          </div>
        );
      } else if (exist === 3) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-danger"
              onClick={() => {
                setPass("");
                setExist(1);
              }}
            >
              بازگشت
            </button>
          </div>
        );
      } else if (exist === 4) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-success"
              onClick={() => {
                setExist(1);
              }}
            >
              ورود
            </button>
          </div>
        );
      } else if (exist === 5) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-success"
              onClick={() => {
                setExist(2);
              }}
            >
              ثبت نام مجدد
            </button>
          </div>
        );
      }
    } else {
      return (
        <div className="row justify-content-center m-5 p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
  };

  if (props.type === "icon") {
    if (loginContext.loginState) {
      return (
        <>
          <button
            className={
              theme === "light"
                ? "btn btn-dark btn-sm ml-2  btn-sm"
                : "btn btn-light btn-sm ml-2  btn-sm"
            }
            // className="btn btn-dark btn-sm ml-2  p-0"
            onClick={() => {
              setShowPoll(true);
              setShowProfile(false);
            }}
          >
            نظرسنجی <FontAwesomeIcon icon={faPoll} />
          </button>

          <Modal
            show={showPoll}
            onHide={() => {
              setShowPoll(false);
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header className="bg-blue text-light rtl justify-content-center">
              شرکت در نظرسنجی و دریافت هدیه
            </Modal.Header>
            <Modal.Body className="bg-blue text-light">{modal()}</Modal.Body>
            <Modal.Footer className="bg-blue inlined text-light">
              <button
                className="btn btn-danger "
                onClick={() => {
                  setShowPoll(false);
                  setShowProfile(true);
                }}
              >
                انصراف
              </button>
              <button className="btn btn-success" onClick={() => pollSubmit()}>
                ثبت
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showMsg}
            onHide={() => {
              setShowMsg(false);
              setMsg("");
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              className={
                theme === "light"
                  ? "bg-light text-dark rtl justify-content-center"
                  : "rtl justify-content-center bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              {msg !== "" ? (
                <h5 className="text-center">{msg}</h5>
              ) : (
                <div className="row justify-content-center m-5 p-5">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <button
                className="btn btn-dark"
                onClick={() => {
                  setShowMsg(false);
                  setMsg("");
                }}
              >
                بستن
              </button>
            </Modal.Footer>
          </Modal>
        </>
      );
    } else {
      return (
        <>
          <button
            className={
              theme === "light"
                ? "btn btn-dark btn-sm ml-2  btn-sm"
                : "btn btn-light btn-sm ml-2  btn-sm"
            }
            onClick={() => {
              setShowSignup(true);
            }}
          >
            نظرسنجی <FontAwesomeIcon icon={faPoll} />
          </button>
          <Modal
            show={showSignup}
            onHide={() => {
              setShowSignup(false);
            }}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              closeButton
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              {loginModal()}
            </Modal.Body>
          </Modal>
        </>
      );
    }
  } else {
    return (
      <>
        <Nav.Link
          onClick={() => {
            setShowProfile(true);
          }}
          href="#"
          className={theme === "light" ? "text-dark" : "text-light"}
        >
          پروفایل
        </Nav.Link>

        <Modal
          show={showProfile}
          onHide={() => setShowProfile(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            پروفایل و نظرسنجی
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <div className="text-center mb-4">
              <label htmlFor="upload-button">
                {image.preview === "" ? (
                  <>
                    <FontAwesomeIcon icon={faUserCircle} size="5x" />
                  </>
                ) : (
                  <img className="image rounded-circle" src={image.preview} />
                )}
              </label>
              <input
                id="upload-button"
                style={{ display: "none" }}
                type="file"
                onChange={imageHandle}
              />
              <p className={theme === "light" ? "text-muted" : "text-light"}>
                برای تغییر عکس پروفایل روی عکس بالا بزنید
              </p>
              <h5 className={theme === "light" ? "text-dark" : "text-light"}>
                {data.mobile + " "}
                <FontAwesomeIcon icon={faMobileAlt} />
              </h5>
            </div>
            <div className="mt-4 text-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowPoll(true);
                  setShowProfile(false);
                }}
              >
                شرکت در نظرسنجی
              </button>
            </div>
            <div className="mt-4">
              <h6 className="mt-3 text-center">نام و نام خانوادگی</h6>
              <input
                className={"form-control rtl"}
                placeholder="نام"
                type="text"
                value={name}
                onChange={nameHandle}
              ></input>
            </div>

            <div className="mt-4">
              <h6 className="mt-3 text-center">کد ملی</h6>
              <input
                className={"form-control rtl"}
                type="text"
                inputMode="numeric"
                maxLength="10"
                value={codeMelli}
                onChange={codeMelliHandle}
              ></input>
            </div>

            <div className="mt-4">
              <h6 className="mt-3 text-center">رسته</h6>
              <select
                className="form-control rtl"
                value={work}
                onChange={workHandle}
              >
                <option value={"مشتری خانگی"}>مشتری خانگی</option>
                <option value={"طلا فروش"}>طلا فروش</option>
                <option value={"جواهر فروش"}>جواهر فروش</option>
                <option value={"بنکدار"}>بنکدار</option>
                <option value={"سازنده"}>سازنده</option>
                <option value={"کیفی"}>کیفی</option>
                <option value={"متفرقه"}>متفرقه</option>
              </select>
            </div>

            <div className="mt-4">
              <h6 className="mt-3 text-center">آدرس</h6>
              <textarea
                className={"form-control text-center rtl"}
                placeholder="آدرس"
                value={address}
                onChange={addressHandle}
              />
            </div>
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowProfile(false)}
            >
              بستن
            </button>
            <button
              className="btn btn-success"
              onClick={() => {
                submit();
              }}
            >
              ثبت تغییرات
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showPoll}
          onHide={() => {
            setShowPoll(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header className="bg-blue text-light rtl justify-content-center">
            نظرسنجی
          </Modal.Header>
          <Modal.Body className="bg-blue text-light">{modal()}</Modal.Body>
          <Modal.Footer className="bg-blue inlined text-light">
            <button
              className="btn btn-danger "
              onClick={() => {
                setShowPoll(false);
                setShowProfile(true);
              }}
            >
              انصراف
            </button>
            <button className="btn btn-success" onClick={() => pollSubmit()}>
              ثبت
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showMsg}
          onHide={() => {
            setShowMsg(false);
            setMsg("");
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          ></Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {msg !== "" ? (
              <h5 className="text-center">{msg}</h5>
            ) : (
              <div className="row justify-content-center m-5 p-5">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => {
                setShowMsg(false);
                setMsg("");
              }}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
};

export default Profile;
